import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { authQueryKey, recover } from '../../lib/auth.ts';
import { m } from '../../paraglide/messages.js';
import { Button } from '../../ui/Button.tsx';
import { TextField } from '../../ui/TextField.tsx';

/** Lost every passkey: a recovery code signs in just far enough to add a new one. */
export function RecoverForm() {
  const queryClient = useQueryClient();
  const [code, setCode] = useState('');
  const mutation = useMutation({
    mutationFn: () => recover(code),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: authQueryKey }),
  });

  return (
    <form
      className="auth__form recover-form"
      onSubmit={(e) => {
        e.preventDefault();
        mutation.mutate();
      }}
    >
      <TextField
        label={m.recover_code_label()}
        required
        mono
        autoComplete="one-time-code"
        autoCapitalize="characters"
        spellCheck={false}
        value={code}
        onChange={(e) => setCode(e.target.value)}
        error={mutation.isError ? m.recover_invalid() : null}
      />
      <Button type="submit" size="m" loading={mutation.isPending}>
        {m.recover_submit()}
      </Button>
    </form>
  );
}
